import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';
import { AppOverlayConfig, OverlayService } from './overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@app/core/language/language.service';

export const TYPES_LOADING = {
  'GENERIC' : 'generic',
  'PROGRESS' : 'progress',
  'SPINNER' : 'spinner'
};

export const TYPES_MODE_LOADING = {
  'DETERMINATE' : 'determinate',
  'INDETERMINATE' : 'indeterminate'
};

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})

export class LoadingComponent implements OnInit {

  @Input() type: string = TYPES_LOADING.GENERIC;
  @Input() showLoading: Boolean;
  @Input() value: Number = 0;
  public mode: string = TYPES_MODE_LOADING.INDETERMINATE;
  public showHeader: Boolean = true;
  public backdropEnabled = false;
  public positionGloballyCenter = false;

  @ViewChild('progressSpinnerRef')
  private progressSpinnerRef: TemplateRef<any>;
  private progressSpinnerOverlayConfig: AppOverlayConfig;
  private overlayRef: OverlayRef;

  constructor(
    private vcRef: ViewContainerRef,
    private overlayService: OverlayService,
    public translate: TranslateService = null,
    private languageService: LanguageService
  ) {
    /** FIXME: Não deveria ser necessário usar o @ngx-translate da forma abaixo.
    Voltamos o codigo anterior, agora refatorado, ja que alguns componentes nao sao traduzidos sem ele
    */
    translate.addLangs(this.languageService.getSiteLanguageCodes());
    translate.use(this.languageService.siteLanguage);
  }


  ngOnInit() {
    this.bootstrapLoading();
    this.configOverlay();
  }

  ngDoCheck() {
    // Based on status of showLoading attach/detach overlay to progress spinner template
    if (this.showLoading && !(this.overlayRef && this.overlayRef.hasAttached())) {
      if(this.progressSpinnerRef && this.vcRef) {
        this.overlayService.attachTemplatePortal(this.overlayRef, this.progressSpinnerRef, this.vcRef);
      }
    } else if (!this.showLoading && this.overlayRef && this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
  }

  private bootstrapLoading() {
    let values = Object.keys(TYPES_LOADING).map(e => TYPES_LOADING[e]);
    if (!values.includes(this.type)) {
      return this.type = TYPES_LOADING.GENERIC;
    }

    if (this.type !== TYPES_LOADING.GENERIC) {
      this.showHeader = false;
      this.backdropEnabled = true;
      this.positionGloballyCenter = true;
    }

    if (this.type === TYPES_LOADING.PROGRESS) {
      this.mode = TYPES_MODE_LOADING.DETERMINATE;
    }
  }

  configOverlay() {
    // Config for Overlay Service
     this.progressSpinnerOverlayConfig = {
      hasBackdrop: this.backdropEnabled
    };

    if (this.positionGloballyCenter) {
      this.progressSpinnerOverlayConfig['positionStrategy'] = this.overlayService.positionGloballyCenter();
    }

    // Create Overlay for progress spinner
    this.overlayRef = this.overlayService.createOverlay(this.progressSpinnerOverlayConfig);
  }

}
